import { Node } from 'slate';

import { ELEMENT_PARAGRAPH } from '../../../slatePlugins';
import { normalizeHyperlinkNode } from './normalizers/each-node/normalizeHyperlinkNode';
import { normalizeEachNode } from './normalizers/each-node/normalizer';
import { normalizeAllNode } from './normalizers/all-nodes/normalizer';
import { removeAllNodesHasEmptyChildrenProp } from './normalizers/all-nodes/removeAllNodesHasEmptyChildrenProp';
import { normalizeNodeShouldHaveData } from './normalizers/each-node/normalizeNodeShouldHaveData';
import { elementNodeShouldHaveChildren } from './normalizers/each-node/elementNodeShouldHaveChildren';
import { normalizeNodeShouldHaveId } from './normalizers/each-node/normalizeNodeShouldHaveId';
import { nodeParagraphShouldNotContainTable } from './normalizers/each-node/nodeParagraphShouldNotContainTable';

export const trimEmptyParagraph = (arr) => {
  return arr?.filter
    ? arr.filter((item) => {
        if (item.type === ELEMENT_PARAGRAPH) {
          const nodeText = Node.string(item);

          if (item?.children?.some((n) => Boolean(n.type))) {
            return true;
          }

          if (nodeText.trim().length === 0) {
            return false;
          }
        }
        return true;
      })
    : [];
};

const normalizeOnEachNodeFns = [
  normalizeHyperlinkNode,
  normalizeNodeShouldHaveData,
  elementNodeShouldHaveChildren,
  normalizeNodeShouldHaveId,
  nodeParagraphShouldNotContainTable,
];

const normalizeAllNodesFns = [
  normalizeEachNode(normalizeOnEachNodeFns),
  removeAllNodesHasEmptyChildrenProp,
];

export const patchFixInvalidNode = (arr) => {
  return normalizeAllNode(arr, normalizeAllNodesFns);
};
